"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataKind = exports.LayoutKind = exports.DesignLibraryMode = void 0;
/** Represents the mode of the Design Library. */
var DesignLibraryMode;
(function (DesignLibraryMode) {
    /** Normal mode */
    DesignLibraryMode["Normal"] = "library";
    /** Metadata mode */
    DesignLibraryMode["Metadata"] = "library-metadata";
})(DesignLibraryMode || (exports.DesignLibraryMode = DesignLibraryMode = {}));
/**
 * Represents the Editing Layout variant.
 * - shared - shared layout
 * - final - final layout
 */
var LayoutKind;
(function (LayoutKind) {
    LayoutKind["Final"] = "final";
    LayoutKind["Shared"] = "shared";
})(LayoutKind || (exports.LayoutKind = LayoutKind = {}));
/**
 * Represents the kind of metadata element.
 * - open - starting chrome element
 * - close - closing chrome element
 */
var MetadataKind;
(function (MetadataKind) {
    MetadataKind["Open"] = "open";
    MetadataKind["Close"] = "close";
})(MetadataKind || (exports.MetadataKind = MetadataKind = {}));
